import { Injectable } from '@angular/core';

import { FullActivity, FullCategory } from '../../../state/category/category.query';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridUomService {
  parseCategoryUom(category: FullActivity | FullCategory, isChild: boolean): string {
    if (!isChild) {
      return '-';
    }

    if ('uom' in category) {
      return `${category.uom || ''}`;
    }

    return '-';
  }
}
